export function label(ctx) {
    return {
        // Firmware's label_init() and its LV_THEME_LABEL theme_apply case are both
        // completely empty (lv_theme_material.c:347-352,1079-1080) — Material applies no
        // style at all to LV_LABEL_PART_MAIN. What actually renders is text_color inherited
        // from the parent's already-resolved (inheritable) style, which this designer has no
        // equivalent cascade for. text_color here is a DESIGNER-SPECIFIC approximation of that
        // inheritance (the theme's general text color), not a literal firmware default.
        // bg_color/bg_opa/border/radius are deliberately left unset to match firmware's "no
        // background" default (previously `radius: 8` leaked through here despite no bg_opa
        // ever being set, a dead no-op — removed).
        styles: {
            main: { text_color: ctx.COLOR_BG_TEXT, text_font: 32, text_letter_space: 0, text_decor: 0 },
        },
    };
}
